import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('❌ PWA ErrorBoundary:', error);
    console.error('❌ Error info:', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: '#f8fafc',
          padding: '24px',
          textAlign: 'center'
        }}>
          <h2 style={{ fontSize: '20px', color: '#0f172a' }}>Une erreur est survenue</h2>
          <p style={{ color: '#475569', maxWidth: '520px' }}>
            L’application a rencontré un problème après la connexion. Tu peux réessayer ou réinitialiser la session.
          </p>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#2563eb',
                color: '#fff',
                border: 'none',
                padding: '10px 16px',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              Réessayer
            </button>
            {this.props.onReset && (
              <button
                onClick={this.props.onReset}
                style={{
                  background: '#e2e8f0',
                  color: '#0f172a',
                  border: 'none',
                  padding: '10px 16px',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
              >
                Réinitialiser
              </button>
            )}
          </div>
          {this.state.error?.message && (
            <p style={{ color: '#94a3b8', fontSize: '12px' }}>
              {this.state.error.message}
            </p>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
